import React from 'react';
import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';
import { Room, Call, Email } from '@material-ui/icons';
import { Typography } from '@material-ui/core';
import parse from 'html-react-parser';
import { getContactUsInfo } from '../../../services';

type InfoDetailProps = {
  color?: string;
  colorIcon?: string | undefined;
};

const StyledInfoWrap = styled.div`
  display: flex;
  margin-bottom: 16px;
`;

const StyledInfoLeft = styled.div`
  margin-right: 24px;
`;

const StyledInfoRight = styled.div`
  flex: 1;
`;

const useStyles = makeStyles((theme) => ({
  title: {
    fontWeight: 800,
  },
  subTitle: {
    color: theme.palette.grey[400],
  },
}));

const InfoDetail = ({ color, colorIcon }: InfoDetailProps) => {
  const classes = useStyles();
  const [contactUs, setContactUs] = React.useState({
    companyName: '',
    address: '',
    email: '',
    tlp: [],
    fb: '',
    ig: '',
    tw: '',
    yt: '',
  });

  const { companyName, address, email, tlp } = contactUs;

  const fetchContectUsInfo = async () => {
    try {
      const res = await getContactUsInfo();
      setContactUs(res.data);
    } catch (err: any) {
      console.log(err.message);
    }
  };

  React.useEffect(() => {
    fetchContectUsInfo();
  }, []);

  return (
    <div>
      <StyledInfoWrap>
        <StyledInfoLeft>
          <Room style={{ color: colorIcon }} />
        </StyledInfoLeft>
        <StyledInfoRight>
          <Typography
            className={classes.title}
            style={{ color: color, marginBottom: '1rem' }}
            gutterBottom
          >
            {companyName}
          </Typography>
          <div style={{ color: color }}>{parse(address)}</div>
        </StyledInfoRight>
      </StyledInfoWrap>
      <StyledInfoWrap>
        <StyledInfoLeft>
          <Call style={{ color: colorIcon }} />
        </StyledInfoLeft>
        <StyledInfoRight>
          {tlp.map((r, i) => (
            <Typography key={i} gutterBottom style={{ color: color }}>
              {r}
            </Typography>
          ))}
        </StyledInfoRight>
      </StyledInfoWrap>
      <StyledInfoWrap>
        <StyledInfoLeft>
          <Email style={{ color: colorIcon }} />
        </StyledInfoLeft>
        <StyledInfoRight>
          <Typography gutterBottom style={{ color: color }}>
            {email}
          </Typography>
        </StyledInfoRight>
      </StyledInfoWrap>
    </div>
  );
};

export default InfoDetail;
